import React from 'react'
import { chakra, forwardRef, Box, BoxProps } from '@chakra-ui/react'

const IconLinkBoxGroupItem = chakra('li', {
  baseStyle: {
    listStyle: 'none',
  },
})

export const IconLinkBoxGroup = forwardRef<BoxProps, 'div'>(({ children, ...rest }, ref) => {
  const margin = 2
  const _children = React.Children.toArray(children).map((child, index) => (
    <IconLinkBoxGroupItem
      key={index}
      width={[
        '100%',
        'calc(50% - 0.5rem)',
        'calc(calc(100% - 2rem) / 3)',
        'calc(calc(100% - 4rem) / 5)',
      ]}
      mx={[0, margin]}
      mb={4}
      __css={{
        ':nth-of-type(odd)': {
          ml: [null, 0, margin],
        },
        ':nth-of-type(even)': {
          mr: [null, 0, margin],
        },
        ':nth-of-type(3n)': {
          mr: [null, null, 0, margin],
        },
        ':nth-of-type(4n)': {
          ml: [null, null, 0, margin],
        },
        ':nth-of-type(5n)': {
          mr: [null, null, null, 0],
        },
        ':nth-of-type(6n)': {
          ml: [null, null, null, 0],
        },
        ':nth-of-type(1)': {
          ml: 0,
        },
        ':last-of-type': {
          mr: 0,
        },
      }}
    >
      {child}
    </IconLinkBoxGroupItem>
  ))
  return (
    <Box
      ref={ref}
      as="ul"
      display="flex"
      flexDirection={'row'}
      justifyContent="center"
      alignItems="stretch"
      flexWrap="wrap"
      mb={-4}
      {...rest}
    >
      {_children}
    </Box>
  )
})
